/**
 * URL-hash keys for the OCR feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#results/5`).
 */
export const OCR_HASH = {
  /** `#create-test` — CreateTestContainerDialog. */
  createTest: 'create-test',
  /** `#template-pool/<containerId>` — OcrTemplatePoolDialog (start OCR). */
  templatePool: 'template-pool',
  /** `#history/<containerId>` — ContainerRepairHistoryDialog (repair cycles). */
  repairHistory: 'history',
  /** `#results/<containerId>` — ContainerResultsSheet (the page/field summary). */
  results: 'results',
  /**
   * `#results-view/<containerId>[/page/<n>|/field/<resultId>/<page>/<key>]` —
   * ContainerResultsOverlay, the full extraction panel shown IN the OCR screen
   * (OMA-635). The tail is the same target the standalone route carries in its
   * fragment; see `utils/results-deep-link.ts`.
   */
  resultsView: 'results-view',
  /** `#pdf/<batchId>` — batch PDF viewer dialog. */
  pdf: 'pdf',
  /** `#repair/<containerId>` — MoveToRepairDialog. */
  moveToRepair: 'repair',
  /** `#delete/<containerId>` — delete-test-container confirmation. */
  deleteTest: 'delete',
  /** `#history` — OcrHistorySheet (previous results, container detail panel). */
  history: 'history'
} as const;

export type OcrHashKey = (typeof OCR_HASH)[keyof typeof OCR_HASH];

/**
 * How many templates the Start OCR dialog's "Pick templates" tab lets the
 * operator select. TEMPORARY, UI-ONLY limit (product decision, 2026-09): the
 * backend still accepts a multi-template pool and runs a per-page
 * classification pass when given two or more. Raise this to re-enable the
 * multi-select picker — the dialog switches back to checkboxes and the
 * "N selected" counter when it is greater than 1.
 */
export const OCR_TEMPLATE_PICKER_MAX = 1;
